import Component from './component';
import { makeDefault } from './defaults';
import { isValidData } from './validator';

export const Shape = {
  Component,
  makeDefault,
  isValidData,
} as const;

export type { ShapeData, ShapeNodeData, ShapeKind } from './types';
export { SHAPE_COMPONENTS } from './shapes';
